import { Component, Input, SimpleChanges } from '@angular/core';
import { Chart, ChartDataset, ChartOptions, Color, registerables } from 'chart.js';
import { Subscription } from 'rxjs';
import { TimeFrameMode } from 'src/app/shared/interfaces/global-filter-model';
import { MondelezDataService } from 'src/app/shared/services/mondelez-data.service';
import { PrecisionType } from 'src/app/shared/interfaces/chart.model';
import { GlobalFilterService } from 'src/app/shared/services/global-filter.service';

Chart.register(...registerables);

@Component({
  selector: 'app-warehouse-cases-chart',
  templateUrl: './warehouse-cases-chart.component.html',
  styleUrls: ['./warehouse-cases-chart.component.scss'],
})
export class WarehouseCasesChartComponent {
  @Input() throughputData: any;
  @Input() showTimeFrameModeToggle = true;

  public dataExistsWithData: boolean = true;

  private yearRange = {
    startYear: undefined,
    endYear: undefined,
  };
  public timeFrameMode: TimeFrameMode;
  public chartParams = [];
  public chartData = {
    year: {},
    quarter: {},
  };
  private config;

  private subs = new Subscription();

  constructor(
    private mondelezDataService: MondelezDataService,
    private globalFilterService: GlobalFilterService,
  ) {
    this.config = {
      DC: {
        name: 'DC',
        type: 'bar',
        label: 'DCs Demand',
        color: '#747480',
        stacked: true,
        stack: '0',
        legend: { isTop: true, isRight: false },
        precision: PrecisionType.NONE,
        dataLabel: { color: '#2E2E38 ', border: '#2E2E38 ', bg: '#EAEAF2' },
      },
      Branch: {
        name: 'Branch',
        type: 'bar',
        label: 'Branches Demand',
        color: '#C4C4CD',
        stacked: true,
        stack: '0',
        precision: PrecisionType.NONE,
        legend: { isTop: true, isRight: false },
        titleY: 'Number of Cases (MM)',
        dataLabel: { color: '#2E2E38 ', border: '#2E2E38 ', bg: '#EAEAF2' },
      },

      DC_throughput: {
        name: 'DC_throughput',
        type: 'bar',
        label: 'DCs Throughput',
        color: '#FBCC79',
        stacked: true,
        stack: '1',
        precision: PrecisionType.NONE,
        dataLabel: { color: '#8E7A57', border: '#8E7A57', bg: '#FCF8EE' },
      },
      Branch_throughput: {
        name: 'Branch_throughput',
        type: 'bar',
        label: 'Branches Throughput',
        color: '#FDEBCB',
        stacked: true,
        stack: '1',
        precision: PrecisionType.NONE,
        dataLabel: { color: '#8E7A57', border: '#8E7A57', bg: '#FCF8EE' },
      },
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.timeFrameMode) {
      this.prepareChart();
    }
  }

  ngOnInit(): void {
    this.subs.add(
      this.globalFilterService.globalFilters.subscribe((filter) => {
        this.yearRange.startYear = filter.start_year;
        this.yearRange.endYear = filter.end_year;
      }),
    );
    this.subs.add(
      this.mondelezDataService.timeFrameMode.subscribe((value) => {
        this.timeFrameMode = value;
        this.prepareChart();
      }),
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private prepareChart() {
    this.chartParams = [];
    Object.keys(this.config)
      .filter((ele) => Object.keys(this.throughputData['current_throughput']['year']).includes(ele.split('_')[0]))
      .forEach((el) => {
        this.chartParams.push(this.config[el]);
      });

    this.chartData[this.timeFrameMode]['DC'] = this.calculateVals('current_throughput', 'DC');
    this.chartData[this.timeFrameMode]['Branch'] = this.calculateVals('current_throughput', 'Branch');
    this.chartData[this.timeFrameMode]['DC_throughput'] = this.calculateVals('simulated_throughput', 'DC');
    this.chartData[this.timeFrameMode]['Branch_throughput'] = this.calculateVals('simulated_throughput', 'Branch');
  }

  private calculateVals(type, graph) {
    if (!Object.keys(this.throughputData[type][this.timeFrameMode]).includes('DC')) {
      this.dataExistsWithData = true;
    } else {
      this.dataExistsWithData = false;
    }
    if (this.throughputData != undefined && Object.keys(this.throughputData[type][this.timeFrameMode]).includes(graph)) {
      return this.throughputData[type][this.timeFrameMode][graph].map((el) => this.formatNumbers(el));
    } else {
      return [];
    }
  }

  private formatNumbers(amt: number) {
    if (!amt) return 0;
    let millionth = amt / 1000000;
    return parseFloat(millionth.toFixed(1));
  }

  onTimeFrameChange(value: TimeFrameMode) {
    this.mondelezDataService.updateTimeFrameMode(value);
  }
}
